import { flushSync } from "react-dom";
import { currentLifetime, isCurrent } from "../../lib/lifetime";
import type { SwapKind } from "../../lib/transition";

let sequence = 0;
let current: ViewTransition | undefined;
/** One coordinator per document; runtime and UI both use this commit barrier. */
export function swap(kind: SwapKind, commit: () => void): void {
  const lifetime = currentLifetime();
  if (
    typeof document === "undefined" ||
    typeof document.startViewTransition !== "function" ||
    (typeof matchMedia === "function" && matchMedia("(prefers-reduced-motion: reduce)").matches)
  ) {
    if (isCurrent(lifetime)) commit();
    return;
  }
  const id = ++sequence;
  current?.skipTransition();
  document.documentElement.dataset["vt"] = kind;
  const transition = document.startViewTransition(() => {
    if (isCurrent(lifetime)) flushSync(commit);
  });
  current = transition;
  void transition.finished
    .catch(() => {})
    .finally(() => {
      if (sequence === id) {
        delete document.documentElement.dataset["vt"];
        current = undefined;
      }
    });
}
